module.exports = __webpack_public_path__ + "static/media/custom.127170c0.jpg";